const clb = (data) => { };
const isFunction = (f) => {
    if (f) {
        return typeof f === 'function';
    }
    else {
        return false;
    }
};
const sendCommand = (data, onSuccess = clb, onFailure = clb) => {
    if (!isFunction(window.jsHostQuery)) {
        console.warn('window.jsHostQuery does not exist and call with', data);
        return false;
    }
    return window.jsHostQuery({
        request: JSON.stringify(data),
        persistent: false,
        onSuccess: onSuccess,
        onFailure: onFailure,
    });
};
export const sendAction = (params) => {
    sendCommand({
        command: "action",
        params,
    });
};
export default sendCommand;
